export default "__VITE_ASSET__d8a16d52__"